import { useTranslation } from "@next-platform/client-common-core";
import { ListEmpty } from "@next-platform/client-common-spicy-ui";
import React, { useCallback } from "react";

import { ROUTES } from "@/constants";
import useLocalizedNavigation from "@/hooks/useLocalizedNavigation";

const DiscoverUnavailable = () => {
  const { t } = useTranslation();
  const localizedNavigate = useLocalizedNavigation();

  const handleHomeClick = useCallback(() => {
    localizedNavigate(ROUTES.home);
  }, [localizedNavigate]);

  return (
    <div data-testid="DiscoverUnavailable" className="flex w-full grow items-center justify-center py-16">
      <ListEmpty
        isLoading={false}
        title={t("error:title.somethingWentWrong")}
        description={t("error:description.refreshOrTryLater")}
        buttonText={t("appMenu:home")}
        onClick={handleHomeClick}
      />
    </div>
  );
};

export default React.memo(DiscoverUnavailable);
